import React, { useState } from 'react';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { emailValidator } from '../../common/sharedFunctions';
import { phoneValidator } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import { EmailPhoneInput } from '../EmailPhoneInput/EmailPhoneInput';

export const Search = ({ handleSearch }) => {
  const [emailInput, setEmailInput] = useState('');
  const [phoneInput, setPhoneInput] = useState('');

  const handleSearchClick = () => {
    const email = emailValidator(emailInput) ? emailInput : undefined;
    const phone = phoneValidator(phoneInput) ? phoneInput : undefined;
    handleSearch(email, phone);
  };

  return (
    <div className="component">
      <EmailPhoneInput
        name="search"
        emailCallback={setEmailInput}
        emailValue={emailInput}
        phoneCallback={setPhoneInput}
        phoneValue={phoneInput}
      />
      <Row>
        <Col nopadding xs={7} sm={8} md={8} lg={8} />
        <Col xs={5} sm={4} md={4} lg={4}>
          <Button data-testid="searchButton" onClick={handleSearchClick}>Search</Button>
        </Col>
      </Row>
    </div>
  );
};

Search.propTypes = {
  handleSearch: PropTypes.func.isRequired,
};
